<template>
  <div>
    <div>
      <!-- Home page content -->
      <main role="main" class="">
        <div class="text-center py-md-5 px-md-4 py-3 container">
          <h1 class="text-center text-pg-blue mb-4 fw-normal" v-html="$t('Home.BannerTitle')">
          </h1>
          <p class="mb-0" v-html="$t('Home.BannerDesc')"></p>
        </div>

        <div class="text-center readytosubmit mb-5 container">
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-sm-12 text-sm-center">
              <h2>{{ $t('Home.ReadytoSubmitTitle') }}</h2>
              <p class="mb-4 pb-2" v-html="$t('Home.ReadytoSubmitDesc')"></p>
              <router-link to="/Upload" class="btn btn-link">
                {{ $t('Home.GetStartedBtn') }}</router-link>
              <div class="mt-4 pt-2 mb-2">
                <small v-html="$t('Home.ParticipatingProductLink')"></small>
              </div>
              <div class="mb-2">
                <small>
                  <router-link to="/Support" class="anc-link">{{ $t('Home.HavingTroubleLink')
                  }}</router-link>
                </small>
              </div>
              <diV>
                <small><a href="https://www.ocedar.com/floor-cleaning-pacs" target="_blank">Where to Buy ›</a></small>
              </div>
            </div>
          </div>
        </div>

        <div class="how-to-blk">
          <div class="container">
            <h2 class="text-center mb-md-5 mb-4">{{ $t('Home.HowToParticipateTitle') }}</h2>
            <div class="row text-center d-flex justify-content-center">
              <div class="col-md-3 home-card-bg">
                <div class="home-card">
                  <img :src="$t('Home.ShopImg')" alt="Shop" class="img-fluid mb-3" />
                  <h4>{{ $t('Home.ShopTitle') }}</h4>
                  <p>
                    <small v-html="$t('Home.ShopDetail')"></small>
                  </p>
                </div>
              </div>

              <div class="col-md-3 home-card-bg">
                <div class="home-card">
                  <img :src="$t('Home.SnapImg')" alt="Snap" class="img-fluid mb-3" />
                  <h4>{{ $t('Home.SnapTitle') }}</h4>
                  <p>
                    <small v-html="$t('Home.SnapDetail')"></small>
                  </p>
                </div>
              </div>
              <div class="col-md-3 home-card-bg">
                <div class="home-card">
                  <img :src="$t('Home.SendImg')" alt="Send" class="img-fluid mb-3" />
                  <h4>{{ $t('Home.SendTitle') }}</h4>
                  <p>
                    <small v-html="$t('Home.SendDetail')"></small>
                  </p>
                </div>
              </div>
              <div class="col-md-3 home-card-bg">
                <div class="home-card">
                  <img :src="$t('Home.RegisterImg')" alt="Register" class="img-fluid mb-3" />
                  <h4>{{ $t('Home.RegisterTitle') }}</h4>
                  <p>
                    <small v-html="$t('Home.RegisterDetail')"></small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container text-center mt-5">
          <h4>Why O-Cedar<sup>®</sup> PACS?</h4>
          <div class="row justify-content-center mt-4 mb-4">
            <div class="col-md-3 mb-3">Perfectly portioned cleaning pods for easy mopping</div>
            <div class="col-md-3 mb-3">Enzyme-powered cleaning helps dissolve dirt and grease </div>
            <div class="col-md-3 mb-3">No ammonia, bleach, or parabens</div>
            <div class="col-md-3 mb-3">Convenient, mess-free cleaning</div>
          </div>
          <p class="fw-bold small"><em>Just drop one PACS into your bucket and mop.</em></p>
        </div>

      </main>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
@media screen and (max-width: 575px) {}
</style>

<style scoped>
/* .home-card-bg {
  position: relative;
}
.home-card {
  box-shadow: 0 15px 25px rgba(129, 124, 124, 0.2);
  height: 380px;
  border-radius: 19px;
  backdrop-filter: blur(14px);
  background-color: rgb(255 255 255 / 20%);
  padding: 15px;
  text-align: left;
  line-height: 23px;
  font-size: 1.2rem;
}
.home-card-bg:before {
  content: '';
  position: absolute;
  height: 70px;
  width: 70px;
  top: -9px;
  left: 5px;
  background-color: #bf233a;
  border-radius: 18px;
}
.home-card img {
  height: 70px;
} */
/* .readytosubmit {
  background: #bf233a2b;
  border: 1px solid #bf233a;
  border-radius: 10px;
  padding: 20px 30px;
} */
@media screen and (max-width: 575px) {
  .home-card {
    height: auto;
    margin-bottom: 40px;
  }
}
</style>
